module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blockGraph"
  }, [_c('span', [_vm._v("Last " + _vm._s(_vm.numDays) + " Days")]), _vm._v(" "), _c('div', {
    staticClass: "flexRow graph"
  }, _vm._l((_vm.days), function(day) {
    return _c('static-block-row', {
      attrs: {
        "quota": day.quota,
        "completed": day.completed,
        "color": _vm.color,
        "label": day.label,
        "size": "small",
        "orientation": "vertical",
        "maxNumBlocks": 12
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "stats"
  }, [_c('span', {
    staticClass: "total"
  }, [_vm._v(_vm._s(_vm.total) + " blocks total")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "average"
  }, [_vm._v(_vm._s(_vm.average) + " blocks/day")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9e55d97e!./~/vue-loader/lib/selector.js?type=template&index=0!./dev/src/components/BlockGraph.vue
// module id = ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-9e55d97e!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./dev/src/components/BlockGraph.vue
// module chunks = 0